export default "__VITE_ASSET__f6JF7VQi__"